import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EnterVerifyCodePage } from './enter-verify-code.page';

const routes: Routes = [
  {
    path: '',
    component: EnterVerifyCodePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EnterVerifyCodePage]
})
export class EnterVerifyCodePageModule {}
